// Tab 对应的二级目录 Segment
export const segmentListMap: { [key: string]: { text: string; value: string }[] } = {
  'GRIP Report': [
    {
      text: 'dbi_insights_center_library_grip_competitor_analysis',
      value: 'Competitor Analysis',
    },
    {
      text: 'dbi_insights_center_library_grip_marker_event_recap',
      value: 'Market Event Recap',
    },
  ],
  'Regional Monthly Report': [
    {
      text: 'dbi_insights_center_library_regional_monthly_report_na',
      value: 'NA',
    },
    {
      text: 'dbi_insights_center_library_regional_monthly_report_eu',
      value: 'EU',
    },
    {
      text: 'dbi_insights_center_library_regional_monthly_report_mena',
      value: 'MENA',
    },
    {
      text: 'dbi_insights_center_library_regional_monthly_report_latam',
      value: 'LATAM',
    },
  ],
};
